module.exports = __webpack_public_path__ + "assets/ziyuan_9.4b2642cb.svg";